export enum DirectoryTabs {
  ACTIVE = 'ACTIVE',
  ARCHIVE = 'ARCHIVE',
  ALL = 'ALL',
}
